// src/components/layout/OCLayout.jsx
import React from "react";
import { useLocation } from "react-router-dom";
import OCSidebar from "./OCSidebar";
import OCTopbar from "./OCTopbar";
// import ReportIssueButton from "@components/common/ReportIssueButton"; // hidden per request
import "@styles/opencart-admin.css";

export default function OCLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const location = useLocation();

  // close sidebar when route changes
  React.useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname, location.search]);

  // close with ESC
  React.useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setSidebarOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <div className={"oc-shell" + (sidebarOpen ? " is-sidebar-open" : "")}>
      {/* Overlay should be BEFORE the sidebar for correct stacking */}
      <div className="oc-overlay" onClick={() => setSidebarOpen(false)} />

      <OCSidebar />

      <div className="oc-main">
        {/* You must add a menu button in OCTopbar that calls this */}
        <OCTopbar onMenuClick={() => setSidebarOpen((v) => !v)} />

        {children}
      </div>

      {/* Report-issue button hidden on all pages (per request). Re-enable by
          uncommenting the line below. */}
      {/* <ReportIssueButton /> */}
    </div>
  );
}
